export function isValidInput(inputAmount: string): boolean {
    return Number(inputAmount) > 0;
}
